import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { isTokenValid } from 'hooks/auth/Token';

export const AuthGuard = ({ children }: { children: JSX.Element }) => {
    const { token } = useAuth();
    const location = useLocation();

    const isExpired = !isTokenValid(token, false);
    const hasAccess = isTokenValid(token, true);

    if (isExpired) {
        sessionStorage.setItem('authReturnPath', `${location.pathname}${location.search}${location.hash}`);

        return <Navigate to="/login" replace />;
    } else if (!hasAccess) {
        return <Navigate to="/forbidden" replace />;
    }

    return children;
};